import { CurrencyEnum } from "@finway-group/shared/lib/models"
import { useQuery } from "@tanstack/react-query"
import { MODEL, STALE_TIME_ANALYTICS_MS } from "~Shared/queries/analytics/consts"
import { CacheEnum } from "~Shared/queries/consts"
import { queryPost } from "~Shared/utils/reactQuery.utils"

type CostCenterEmployeeAnalyticsReq = {
    destCurrency: CurrencyEnum
}

type CostCenterEmployeeAnalyticsRes = Array<{
    costCenter: string
    value: number
}>

export const useCostCenterDataForEmployee = ({ employeeId, destCurrency, isEnabled = true }: { employeeId: string; destCurrency: CurrencyEnum; isEnabled?: boolean }) =>
    useQuery({
        queryKey: [CacheEnum.ANALYTICS, employeeId, destCurrency],
        keepPreviousData: true, // cpu intensive for database
        staleTime: STALE_TIME_ANALYTICS_MS,
        enabled: isEnabled,
        queryFn: async ({ signal }): Promise<CostCenterEmployeeAnalyticsRes> =>
            queryPost<CostCenterEmployeeAnalyticsReq, CostCenterEmployeeAnalyticsRes>(`${MODEL}/costcenters/employee/${employeeId}`, { destCurrency }, { signal }),
    })
